import script from "./AccessibilityFeaturesDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityFeaturesDetails.vue?vue&type=script&setup=true&lang=js"

import "./AccessibilityFeaturesDetails.vue?vue&type=style&index=0&id=6e19ec2b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e19ec2b"]])

export default __exports__